import { createSafeContext } from 'app/presentation/utils/createSafeContext';

export const [AccordionContextProvider, useAccordionContext] = createSafeContext(
    "useAccordionContext must be used within AccordionProvider"
);
